export default __webpack_public_path__ + "static/media/pdf-icon.fbe8f06d.svg";